/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Card_WatchInputs */

const en_directory_card_watch = /** @type {(inputs: Directory_Card_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch product`)
};

const zh_directory_card_watch = /** @type {(inputs: Directory_Card_WatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注产品`)
};

/**
* | output |
* | --- |
* | "Watch product" |
*
* @param {Directory_Card_WatchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_card_watch = /** @type {((inputs?: Directory_Card_WatchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Card_WatchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_card_watch(inputs)
	return zh_directory_card_watch(inputs)
});
export { directory_card_watch as "directory.card.watch" }